import { getLocalStorageData } from '../../../utils/helper';
import { APP_API_URL_V2 } from '../../../utils/xhr-instance';
import { axiosInstanceV2 } from '../../axios';

export async function getPreferencesGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/preferences/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdatePreferencesGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/preferences/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getNotificationPreferences() {
	const API_URL = `${APP_API_URL_V2}/notifications/preferences`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data?.data)
		.catch((error) => {
			throw error?.response?.data || error;
		});
}

export async function updateNotificationPreferences(data) {
	const API_URL = `${APP_API_URL_V2}/notifications/preferences`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function triggerTestNotification(data) {
	const API_URL = `${APP_API_URL_V2}/notifications/test-trigger`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data?.data)
		.catch((err) => err?.response?.data || { sent: false, reason: 'Failed to trigger test alert' });
}

export async function getNotificationHistory(params = {}) {
	const API_URL = `${APP_API_URL_V2}/notifications/history`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			params,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data?.data)
		.catch((error) => {
			throw error?.response?.data || error;
		});
}


